import {
    GET_PERSONALDAYS,
    PD_ERROR,
    PD_LOADING,
    GET_CATEGORIES,
    PD_LOADINGCATEGORIES,
    POST_PERSONALDAYS,
    GET_TIMEINTERVALS,
    INITIAL_USER_VALIDATION,
    DELETE_PERSONAL_DAYS,
    UPDATE_REQUEST_DATE,
    PD_LOADING_ACTION,
    PD_LOADING_VALIDATION,
} from '../actions/PersonalDaysActions';

const initialState = {
    validations: { validation: null, comments: null },
    categoryintervals: [],
    personaldays: [],
    categories: [],
    addpersonaldays: {
        validation: false,
        comments: "",
        id: -1
    },
    loading: false,
    loadingAction: false,
    loadingValidation: false,
    loadingcategories: false,
    success: false,
};

const PersonalDaysReducer = function(state = initialState, action){
    switch (action.type) {
        case PD_LOADING: {
            return {
              ...state,
              loading: true
            }
        }
        case PD_LOADINGCATEGORIES: {
            return {
                ...state,
                loadingcategories: true
              }
        }
        case PD_LOADING_ACTION: {
            return {
                ...state,
                loadingAction: true
              }
        }
        case PD_LOADING_VALIDATION: {
            return {
                ...state,
                loadingValidation: true
              }
        }
        case PD_ERROR: {
            const validations =
                action.source === 'validation'
                    ? {
                        validation: false,
                        comments: action.message || 'Unable to verify eligibility. Please try again.',
                    }
                    : state.validations;
            return {
                ...state,
                validations,
                success: false,
                loading: false,
                loadingAction: false,
                loadingcategories: false,
                loadingValidation: false
            }
        }
        case GET_PERSONALDAYS: {
            return {
                ...state,
                personaldays: [...action.data],
                loading: false,
                success: true,
            }
        }
        case INITIAL_USER_VALIDATION: {
            return {
                ...state,
                loadingValidation: false,
                validations: action.data
            }
        }
        case GET_TIMEINTERVALS: {
            return {
                ...state,
                categoryintervals: [...action.data],
                loading: false,
                success: true,
            }
        }
        case GET_CATEGORIES: {
            return {
                ...state,
                categories: action.data,
                loadingcategories: false,
                success: true,
            }
        }
        case POST_PERSONALDAYS: {
            return {
                ...state,
                addpersonaldays: action.data,
                loading: false
            }
        }
        case UPDATE_REQUEST_DATE: {
            return {
                ...state,
                loadingAction: false
            }
        }
        case DELETE_PERSONAL_DAYS: {
            return {
                ...state,
                loadingAction: false
            }
        }
        default: {
            return state;
        }
    }
}

export default PersonalDaysReducer;